import cxs from 'cxs';
import { COLOURS } from '../../../common/styles/vars';

const borderColor = ({ selected, darkMode, disabled }) => {
  if (selected) {
    return disabled ? COLOURS.grey.regent : COLOURS.cyan.jungleGreen.monkey;
  }

  return darkMode ? COLOURS.mono.white : COLOURS.grey.mischka.russian;
};

export const BUTTON_CONTAINER = (
{ selected, darkMode, disabled }) =>
cxs({
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',

  ':hover': !selected && !disabled ? {
    ' > .radio-button__button': {
      borderColor: darkMode ? void 0 : COLOURS.grey.regent,
      borderWidth: darkMode ? '2px' : void 0
    }
  } : {}
});

export const BUTTON_CONTAINER_DISABLED = cxs({
  cursor: 'default'
});

export const BUTTON = (
{ selected, darkMode, disabled }) =>
cxs({
  border: `${selected ? 2 : 1}px solid ${borderColor({ selected, darkMode, disabled })}`,
  borderRadius: '50%',
  width: '20px',
  height: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '20px',
  minHeight: '20px',
  position: 'relative',
  zIndex: 0,
  boxSizing: 'border-box',
  background: darkMode ? COLOURS.mono.white25 : COLOURS.grey.athens.parthenon
});

export const BUTTON_CENTER = ({ disabled }) => cxs({
  background: disabled ? COLOURS.grey.regent : COLOURS.cyan.jungleGreen.monkey,
  borderRadius: '50%',
  width: '12px',
  minWidth: '12px',
  height: '12px',
  minHeight: '12px',
  position: 'relative',
  zIndex: 1
});

export const BUTTON_CONTENT = cxs({
  marginLeft: '20px',
  display: 'flex',
  alignItems: 'center',

  ' > .icon-container': {
    marginRight: '20px'
  }
});

export const BUTTON_DISABLED = cxs({
  background: '#f2f2f2',
  cursor: 'default',
  pointerEvents: 'none'
});